import { useQuery } from '@apollo/client/react';
import { QUERY_DOG_NAMES_PAGE } from '../../graphql/dog-queries';

export default function useGetDogNamesPage(slug) {
    const { data, loading } = useQuery(QUERY_DOG_NAMES_PAGE, { variables: { slug } });
    return { data: data?.dogNamePage, loading };
}
